module.exports = __webpack_public_path__ + "media/images/icons/twotone/minus-square-99e6eeca6b3eb540b5a626caebf0d74f.svg";